module.exports = __webpack_public_path__ + "8e960d6951aa104f0d8ceced9528ebb8.png";